var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkedInIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "rgba(255,255,255,.3)",
    opacity: 0.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.002 20.256A8 8 0 016.346 6.599a8 8 0 1111.313 11.314 7.977 7.977 0 01-5.657 2.343zm2-8.217a.965.965 0 01.828.379 1.827 1.827 0 01.272 1.083v3.421h2.009v-4.126a2.286 2.286 0 00-2.372-2.591 2.289 2.289 0 00-1.5.539 2.11 2.11 0 00-.464.539v-.879h-1.936v6.518h1.936v-3.421a1.655 1.655 0 01.313-1.075 1.126 1.126 0 01.914-.387zm-6.473-1.636v6.518h2.019v-6.517H7.529zm1-3.258a1.2 1.2 0 101.193 1.2 1.2 1.2 0 00-1.192-1.2z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedInIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/linked_in_icon.8f5fe78dbf60e7b796d486ae620e484b.svg";